// src/helpers/alarmDisplay.helper.js

export function getAlarmTypeValue(alarm) {
    return (
        alarm?.alarmTypeId ??
        alarm?.alarmType ??
        alarm?.alarmTypeMeta?.id ??
        null
    );
}

export function resolveAlarmDisplay(alarm, balise = null) {

    const alarmTypeValue = getAlarmTypeValue(alarm);

    const fallbackText =
        alarm?.alarmTypeMeta?.name ||
        alarm?.alertName ||
        "N.C";

    const severity = alarm?.alarmTypeMeta?.severity;

    const fallback = severity === "INFO"
        ? {
            notification: "info",
            text: fallbackText,
            icon: "circle-info",
            color: "alarm-color-info",
            pinColor: "alarm-color-info",
        }
        : {
            notification: "unknown",
            text: fallbackText,
            icon: "triangle-exclamation",
            color: "alarm-color-danger",
            pinColor: "alarm-color-danger",
        };

    switch (alarmTypeValue) {

        // =========================================================
        // TRAJETS
        // =========================================================

        case 1:
            return {
                notification: "start",
                text: "Début trajet",
                icon: "circle-play",
                color: "alarm-color-success",
                pinColor: "alarm-color-info",
            };

        case 2:
            return {
                notification: "finish",
                text: "Fin trajet",
                icon: "flag-checkered",
                color: "alarm-color-muted",
                pinColor: "alarm-color-info",
            };

        // =========================================================
        // VITESSE / CORRIDORING
        // =========================================================

        case 14:
            return {
                notification: "speed",
                text: fallbackText,
                icon: "gauge-high",
                color: "alarm-color-danger",
                pinColor: "alarm-color-danger",
            };

        case 41:
            return {
                notification: "corridoring-in",
                text: fallbackText,
                icon: "circle-check",
                color: "alarm-color-primary",
                pinColor: "alarm-color-info",
            };

        // =========================================================
        // BALISE
        // =========================================================

        case 44:
            return {
                notification: "power-off",
                text: "Extinction de balise",
                icon: "power-off",
                color: "alarm-color-primary",
                pinColor: "alarm-color-info",
            };

        case 66:
            return {
                notification: "tear-off",
                text: "Arrachement",
                icon: "reply",
                color: "alarm-color-danger",
                pinColor: "alarm-color-danger",
            };

        case 67:
            return {
                notification: "opened",
                text: "Balise ouverte",
                icon: "screwdriver",
                color: "alarm-color-danger",
                pinColor: "alarm-color-danger",
            };

        // =========================================================
        // CONTACT
        // =========================================================

        case 45:
            return {
                notification: "contact-on",
                text: "Contact activé",
                icon: "key",
                color: "alarm-color-success",
                pinColor: "alarm-color-info",
            };

        case 46:
            return {
                notification: "contact-off",
                text: "Contact désactivé",
                icon: "key",
                color: "alarm-color-secondary",
                pinColor: "alarm-color-info",
            };

        // =========================================================
        // STATIONNEMENT
        // =========================================================

        case 59:
            return {
                notification: "parking-on",
                text: "Surveillance stationnement ON",
                icon: "car-on",
                color: "alarm-color-info",
                pinColor: "alarm-color-info",
            };

        case 60:
            return {
                notification: "parking-off",
                text: "Surveillance stationnement OFF",
                icon: "car-on",
                color: "alarm-color-warning",
                pinColor: "alarm-color-info",
            };

        // =========================================================
        // MISSIONS
        // =========================================================

        case 61:
            return {
                notification: "mission-start",
                text: "Départ mission",
                icon: "shield-halved",
                color: "alarm-color-info",
                pinColor: "alarm-color-info",
            };

        case 62:
            return {
                notification: "mission-end",
                text: "Fin mission",
                icon: "shield-halved",
                color: "alarm-color-warning",
                pinColor: "alarm-color-info",
            };

        // =========================================================
        // DIGITAL INPUTS
        // =========================================================

        case 25:
        case 26:
        case 27:
        case 28:
        case 29:
        case 30: {

            const index = Math.ceil((alarmTypeValue - 24) / 2);
            const isActive = alarmTypeValue % 2 === 1;

            let name = `Détecteur ${index} ${isActive ? "actif" : "inactif"}`;

            (balise?.digitalIOs || []).forEach((dIO) => {
                if (dIO.index == index) {
                    name = isActive
                        ? dIO.onName
                        : dIO.offName;
                }
            });

            return {
                notification: "detector",
                text: name,
                icon: "triangle-exclamation",
                color: "alarm-color-danger",
                pinColor: "alarm-color-danger",
            };
        }

        // =========================================================
        // DEFAULT
        // =========================================================

        default:
            return fallback;
    }
}